import RichTextStyle from "../templates/RichText.style";
var richtext = {
  name: 'richtext',
  data: [{
    borderColor: '#E8E8E8'
  }],
  onlyTemplate: RichTextStyle
};
export default richtext;